import { ApplicationConfig } from 'ds-shared-lib/src/utils/ApplicationConfig';
import Parameters from 'ds-shared-lib/src/utils/Parameters';

/**
 * Get the initialized Parameters singleton.
 *
 * Parameters.getInstance() awaits ApplicationConfig.configReady, which the PWA
 * never resolves on its own outside of the graph wrapper. Seed a standalone
 * config first so initialization can complete instead of hanging.
 *
 * @returns {Promise<Parameters>} The initialized Parameters instance.
 */
export async function getParameters() {
    if (!ApplicationConfig.getApplicationConfig()) {
        ApplicationConfig.setApplicationConfig({ _pwaStandalone: true });
    }
    return Parameters.getInstance();
}
